import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { fromArrayToString } from '../../../utils/from-array-to-string.js';
import '@grandvisionhq/graphql';
import { getStoredAppointment } from '../../../utils/book-appointment-storage.js';
import useVirtualAppointment from '../hooks/use-virtual-appointment.js';
import { useRoutingContext } from './RoutingContext/context.js';

const defaultState = {
    store: null,
    type: null,
    timeSlot: null,
    appointment: null
};
const useAppointmentState = (initialState = defaultState)=>{
    const [state1, dispatch] = React.useReducer((state, action)=>{
        switch(action.type){
            case 'book-appointment/set-store':
                return swcHelpers.objectSpread({}, state, {
                    store: action.payload
                });
            case 'book-appointment/set-type':
                return swcHelpers.objectSpread({}, state, {
                    type: action.payload
                });
            case 'book-appointment/set-time-slot':
                return swcHelpers.objectSpread({}, state, {
                    timeSlot: action.payload
                });
            case 'book-appointment/set-appointment':
                return swcHelpers.objectSpread({}, state, {
                    appointment: action.payload
                });
            default:
                return state;
        }
    }, initialState);
    const setStore = React.useCallback((store)=>{
        if (state1.store !== store) {
            dispatch({
                type: 'book-appointment/set-store',
                payload: store
            });
        }
    }, [
        state1
    ]);
    const setType = React.useCallback((type)=>{
        if (state1.type !== type) {
            dispatch({
                type: 'book-appointment/set-type',
                payload: type
            });
        }
    }, [
        state1
    ]);
    const setTimeSlot = React.useCallback((timeSlot)=>dispatch({
            type: 'book-appointment/set-time-slot',
            payload: timeSlot
        })
    , []);
    const setAppointment = React.useCallback((appointment)=>dispatch({
            type: 'book-appointment/set-appointment',
            payload: appointment
        })
    , []);
    return React.useMemo(()=>[
            {
                setStore,
                setType,
                setTimeSlot,
                setAppointment
            },
            state1
        ]
    , [
        state1,
        setStore,
        setType,
        setTimeSlot,
        setAppointment
    ]);
};
const appointmentContext = /*#__PURE__*/ React.createContext(null);
const AppointmentContextProvider = ({ children , initialState ,  } = {})=>{
    const { Provider  } = appointmentContext;
    var ref;
    const initialStore = (ref = initialState === null || initialState === void 0 ? void 0 : initialState.store) !== null && ref !== void 0 ? ref : defaultState.store;
    var ref1;
    const initialType = (ref1 = initialState === null || initialState === void 0 ? void 0 : initialState.type) !== null && ref1 !== void 0 ? ref1 : defaultState.type;
    const initialTimeSlot = (initialState === null || initialState === void 0 ? void 0 : initialState.timeSlot) ? {
        from: new Date(parseInt(initialState.timeSlot.from, 10)),
        until: new Date(parseInt(initialState.timeSlot.until, 10))
    } : defaultState.timeSlot;
    const [, { queryParams  }] = useRoutingContext();
    const appointmentId = fromArrayToString(queryParams.appointmentId);
    var ref2;
    const initialAppointment = (ref2 = getStoredAppointment(appointmentId)) !== null && ref2 !== void 0 ? ref2 : null;
    const [{ isVirtualAppointmentStore , isVirtualAppointmentType , getStoreData , getAppointmentTypeData  }, ] = useVirtualAppointment();
    // Enrich virtual appointment type data when provided, for example with bloomreach label values.
    const type = isVirtualAppointmentType(initialType) ? getAppointmentTypeData(initialType) : initialType;
    // Enrich virtual appointment store data when provided, for example with bloomreach label values.
    const store = isVirtualAppointmentStore(initialStore) ? getStoreData(initialStore, type) : initialStore;
    const value = useAppointmentState(swcHelpers.objectSpread({}, defaultState, {
        store,
        type,
        timeSlot: initialTimeSlot,
        appointment: initialAppointment,
        tryInStoreProductSkus: initialState === null || initialState === void 0 ? void 0 : initialState.tryInStoreProductSkus
    }));
    return /*#__PURE__*/ React.createElement(Provider, {
        value: value
    }, children);
};
const useAppointmentContext = ()=>React.useContext(appointmentContext)
;

export { AppointmentContextProvider, appointmentContext, defaultState, useAppointmentContext };
//# sourceMappingURL=AppointmentContext.js.map
